/** @format */

import {
  serviceConfigCheckAsync,
  clearServiceConfigRequestCache,
} from './serviceConfigCheckAsync';

let config = null;

export async function getServiceConfig() {
  if (!config) {
    config = await serviceConfigCheckAsync();
  }

  return config;
}

/**
 * پاک کردن کامل cache مربوط به Service Config.
 */
export function clearServiceConfig() {
  config = null;
  clearServiceConfigRequestCache();
}
